import '../LandingPage.css';
import {
  FaLaptopCode,
  FaMobileAlt,
  FaCloud,
  FaRobot,
  FaDatabase,
  FaShieldAlt,
} from 'react-icons/fa';

const services = [
  {
    icon: FaLaptopCode,
    title: 'Web Application Development',
    description:
      'Fast, reliable web apps that look good, built on modern frameworks with a clean architecture.',
  },
  {
    icon: FaMobileAlt,
    title: 'Responsive & Mobile-First',
    description:
      'Sites and apps that work well on every screen, from phones to widescreen displays.',
  },
  {
    icon: FaCloud,
    title: 'Cloud & Deployment',
    description:
      'Scalable cloud hosting, CI/CD pipelines and production deployments you can rely on.',
  },
  {
    icon: FaRobot,
    title: 'AI & Chat Integration',
    description:
      'AI chat and automation that talk to your customers around the clock.',
  },
  {
    icon: FaDatabase,
    title: 'APIs & Integrations',
    description:
      'Back ends, data modelling and integrations with third-party services.',
  },
  {
    icon: FaShieldAlt,
    title: 'Security & Compliance',
    description:
      'Secure, privacy-aware engineering for regulated industries.',
  },
];

function ServicesSection() {
  return (
    <section id="services" className="services-section section">
      <div className="section-content">
        <div className="section-head reveal">
          <h2 className="section-title">Services built around your goals</h2>
          <p className="section-lead">
            We cover the whole software lifecycle, from the first idea to
            production and the work after launch, so you can focus on your
            business.
          </p>
        </div>

        <div className="services-grid reveal">
          {services.map((service) => {
            const Icon = service.icon;
            return (
              <article key={service.title} className="service-card">
                <Icon className="service-card-icon" aria-hidden="true" />
                <h3 className="service-card-title">{service.title}</h3>
                <p className="service-card-text">{service.description}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;
